import {useGracePeriodNotification} from '@dms/shared';

import {Dashboard} from './Dashboard';

export function Homepage() {
  useGracePeriodNotification();

  return <Dashboard />;
}
